import React from 'react';
import { connect } from "react-redux";
import { login, setLoggedIn } from "../actions/login/authFacebook";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import facebookImage from './fbimg.svg';

const your_app_id = "1868605456900653";

function FacebookSignIn({ login, onClosePopup }) {
  const responseFacebook = (response) => {
    console.log('Facebook User:', response);
    if (response.accessToken) {
      const postData = {
        verfication_code: response.id,
        email: response.email?response.email:'',
        login_type: '2',
        first_name: response.name,
        last_name: ''
      };
      login(postData);
      // onClosePopup();
    }
  };

  return (
    <FacebookLogin
      appId={your_app_id}
      autoLoad={false}
      callback={responseFacebook}
      fields="name,email"
      scope="public_profile,email"
      disableMobileRedirect={true}
      render={renderProps => (
        <div
          onClick={renderProps.onClick}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0 16px",
            borderRadius: "8px",
            border: "1px solid #E9E9E9",
            fontSize: "17px",
            fontWeight: 500,
            fontFamily: "Segoe UI, sans-serif",
            height: "45px",
            width: "90%",
            textAlign: "center",
            gap: "10px",
            margin: "16px auto",
            cursor: "pointer",
            backgroundColor: "#ffffff",
            color: "#000000"
          }}
          className="facebook_btn"
          data-Fus="fus-test-Facebookloginbtn"
        >
          <img
            src={facebookImage}
            alt="Facebook"
            style={{
              width: "18px",
              height: "18px",
              objectFit: "contain",
              marginLeft: "18px"
            }}
          />
          <span >Continue with Facebook</span>
        </div>
      )}
    />
  );
}

const mapStateToProps = (state) => ({
  isLoggedIn: state.userdata.isLoggedIn,
  userData: state.userdata.userData,
});

const mapDispatchToProps = {
  login,
  setLoggedIn,
};

export default connect(mapStateToProps, mapDispatchToProps)(FacebookSignIn);
